import {ProductStockBadge} from "./stock_badge.js";
import {AddToOrderListBtn} from "./add_to_orderlist_btn.js";
import {AddToShoppingCartBtn} from "./add_to_shopping_cart_btn.js";
import {PriceElements} from "./price_elements.js";
import {OrderedBeforeBadge} from "./ordered_before_badge.js";
import {ArticleNumberBadge} from "./article_number_badge.js";
import {ActionProductRibbon} from "./action_product_ribbon.js";
import {ProductImage} from "./product_image.js";

export class ProductTableRow {
    constructor(product, showNetPrices = false) {

        this.product = product;
        this.showNetPrices = showNetPrices;
        this.isSignedIn = $('body').attr('data-is-signed-in') === '1';
    }

    render() {

        return `<tr class="product-search-result-item-row" data-product-id="` + this.product.id + `">
                    ` + new ProductImage(this.product).render() + `
                    <td class="align-middle" onclick="document.location = '/product/` + this.product.id + `'">
                        <div class="d-flex align-items-center">
                            ` + new ArticleNumberBadge(this.product, false).render() + `
                        </div>
                    </td>
                    <td class="align-middle product-link" data-product-id="` + this.product.id + `" onclick="document.location = '/product/` + this.product.id + `'"><h3 class="h6 m-0" style="color: var(--ar-heading-link-color) !important;">` + this.product.description + `</h3></td>
                    <td class="align-middle product-link" data-product-id="` + this.product.id + `" onclick="document.location = '/product/` + this.product.id + `'"><div class="d-flex flex-column justify-content-center align-items-center product-price-elements">` + new PriceElements(this.product, this.showNetPrices).render() + `</div></td>
                    <td class="align-middle position-relative">
                        <div class="d-flex flex-row gap-2 justify-content-end">
                            ` + new OrderedBeforeBadge(this.product, false).render() + `
                            ` + new ProductStockBadge(this.product, false).render() + `
                            ` + new AddToOrderListBtn(this.product, false).render() + `
                            ` + new AddToShoppingCartBtn(this.product, false).render() + `
                        </div>
                        ` + new ActionProductRibbon(this.product, false).render() + `
                    </td>
                </tr>`;
    }
}
